'use client';

import { pretendard, yetHangul } from '@mildang/design-system-legacy/esm/utils/loadFont';
import { hakgyoansimDunggeunmisoBold, hakgyoansimDunggeunmisoRegular } from '../utils/loadFont';

export default function FontVariables() {
  return (
    <style jsx global>
      {`
        :root {
          --font-pretendard-variable: ${pretendard.style.fontFamily};
          --font-hakgyoansim-dunggeunmiso-bold-variable: ${hakgyoansimDunggeunmisoBold.style.fontFamily};
          --font-hakgyoansim-dunggeunmiso-regular-variable: ${hakgyoansimDunggeunmisoRegular.style
            .fontFamily};
          --font-yet-hangul: ${yetHangul.style.fontFamily};
        }
      `}
    </style>
  );
}
